<template>
	<div class="login-wrap">
		<div class="login-card">
			<h2 style="width: 100%;text-align: center;">⚙️ 管理中台登录</h2>

			<!-- 顶部 TAB 切换 -->
			<div class="tab">
				<span @click="loginTyp = 'account'" :class="loginTyp == 'account' ? 'on' : ''">账号登录</span>
				<span @click="loginTyp = 'phone'" :class="loginTyp == 'phone' ? 'on' : ''">手机号登录</span>
			</div>

			<el-form label-width="100px" style="margin-top:15px;">
				<!-- 账号密码登录 -->
				<div v-if="loginTyp == 'account'">
					<el-form-item label="管理员账号">
						<el-input v-model="form.username" @keyup.enter.native="logins" />
					</el-form-item>
					<el-form-item label="密码">
						<el-input v-model="form.password" type="password" @keyup.enter.native="logins" />
					</el-form-item>
				</div>

				<!-- 手机号密码登录 -->
				<div v-if="loginTyp == 'phone'">
					<el-form-item label="手机号">
						<el-input v-model="form.username" @keyup.enter.native="logins" />
					</el-form-item>
					<el-form-item label="密码">
						<el-input v-model="form.password" type="password" @keyup.enter.native="logins" />
					</el-form-item>
				</div>

				<el-form-item>
					<el-button type="primary" @click="logins" style="width:100%">登录后台</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import {
		Message
	} from 'element-ui'
	import {
		loginType
	} from '../login.js'

	export default {
		data() {
			return {
				loginTyp: "account", // 账号/手机号 切换
				form: {
					username: '',
					password: ''
				},
				login: null
			}
		},
		methods: {
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text: text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close()
					this.login = null
				}
			},

			// 登录（管理员：只走单用户，不出现选择界面）
			async logins() {
				if (!this.form.username || !this.form.password) {
					return this.$message.warning("请输入账号密码");
				}

				this.loginOpen('登录中...')

				// 标记：是否手机号登录
				const isPhoneLogin = this.loginTyp === 'phone' ? 1 : 0

				// 管理员登录固定 userType=1
				let loginT = await loginType(
					this.API,
					this.form.username,
					this.form.password,
					1,
					isPhoneLogin
				)

				console.log('loginT', loginT)

				// ------------------------------
				// 管理员：永远只走成功/失败
				// ------------------------------
				if (loginT === 'true') {
					Message.success('登录成功')
					this.noLogin()
					this.$router.push('/admin/dashboard')
				} else {
					this.noLogin()
					Message.error(loginT)
				}
			}
		}
	}
</script>

<style scoped>
	.login-wrap {
		height: 100vh;
		background: #f0f2f5;
		display: flex;
		align-items: center;
		justify-content: center
	}

	.login-card {
		width: 420px;
		background: #fff;
		padding: 35px;
		border-radius: 8px;
		box-shadow: 0 2px 12px #0000001c
	}

	/* TAB 样式 */
	.tab {
		display: flex;
		margin-bottom: 10px;
	}

	.tab span {
		flex: 1;
		text-align: center;
		padding: 6px;
		cursor: pointer;
		font-size: 16px;
	}

	.tab span.on {
		color: #2d8cf0;
		font-weight: bold;
	}
</style>